var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@drawbotics/jakte-plugin-user-agent/node_modules/core-js/internals/uid.js
// module id = 172
// module chunks = 0